import React from 'react';
import {
  Button, Col, Row,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { IoAlertCircleOutline, IoCheckmarkCircleOutline } from 'react-icons/io5';

type SuccessMessageProps = {
  description: string,
  success: boolean,
  onRestart?: () => void,
  primaryButtonLabel?: string,
  onPrimaryClick?: () => void,
  secondaryButtonLabel?: string,
  onSecondaryClick?: () => void,
};

function SuccessMessage( {
  description,
  onRestart,
  success = true,
  primaryButtonLabel,
  onPrimaryClick,
  secondaryButtonLabel,
  onSecondaryClick,
}: SuccessMessageProps ) {
  const { t } = useTranslation();
  const usePrimary = primaryButtonLabel != null && onPrimaryClick != null;
  const useSecondary = secondaryButtonLabel != null && onSecondaryClick != null;

  let buttonLabel: string;
  let buttonOnClick: () => void;
  if ( usePrimary ) {
    buttonLabel = primaryButtonLabel!;
    buttonOnClick = onPrimaryClick!;
  } else if ( success ) {
    buttonLabel = t( 'admin.processes.uploadFile' );
    buttonOnClick = () => {};
  } else {
    buttonLabel = t( 'admin.processes.restart' );
    buttonOnClick = onRestart ?? ( () => {} );
  }

  return (
    <div className="text-center">
      {success === true && ( <IoCheckmarkCircleOutline size={34} className="text--green2" /> )}
      {success === false && ( <IoAlertCircleOutline size={34} className="text-danger" /> )}
      <p
        className={classNames( 'text--sm mt-2', {
          'text--green2': success === true,
          'text-danger': success === false,
        } )}
        style={description.includes( '\n' ) ? { whiteSpace: 'pre-line' } : undefined}
      >
        {description}
      </p>

      <Row>
        <Col md={12} className="m-auto mt-4 d-flex flex-column gap-2">
          {useSecondary && (
            <Button
              variant="outline-primary"
              className="btn--full-width"
              onClick={onSecondaryClick}
            >
              {secondaryButtonLabel}
            </Button>
          )}
          <Button variant="primary" className="btn--full-width" onClick={buttonOnClick}>
            {buttonLabel}
          </Button>
        </Col>
      </Row>
    </div>
  );
}

export default SuccessMessage;
